if(history.scrollRestoration) {
    history.scrollRestoration = 'manual';
}
const checkHash = function(e) {
    const hash = window.location.hash;
    
    if(hash.length && hash.startsWith('#')) {
        const el = document.querySelector(hash);
        
        if(el && el.classList.contains('accordion')) {
            el.classList.add('active');
            // Scroll to the element corresponding to the hash
            const yOffset = document.querySelector('.site-header').offsetHeight + 90;
            const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset * -1;
            window.scrollTo(0, y);
        }
    }
};
window.addEventListener('load', checkHash);
window.addEventListener('hashchange', checkHash);
